import { apiRequest } from './client';

export const fetchSections = async () => apiRequest('/api/sections');

export const saveSectionRequest = async (sectionName, sectionData) =>
  apiRequest(`/api/sections/${sectionName}`, {
    method: 'PUT',
    body: JSON.stringify(sectionData),
  });
